import __request__ from "routing/request";
export function get(streamid) {
  return __request__("GET", `/streams/${streamid}/outputs`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function add(streamid, JSONbody) {
  return __request__("POST", `/streams/${streamid}/outputs`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function remove(streamid, outputId) {
  return __request__("DELETE", `/streams/${streamid}/outputs/${outputId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function getBystreamidAndoutputId(streamid, outputId) {
  return __request__("GET", `/streams/${streamid}/outputs/${outputId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
